import client from "./client";

export const getProfile = (userId) => client.get(`/bios/profile/${userId}`);

// Multipart update: profileImage (file) + text fields (Bio, skills, employment,
// education, projects, volunteer, referees). Content-Type is left for axios/the
// browser to set automatically — manually setting it here would drop the
// multipart boundary and break parsing on the server.
export const updateProfile = (formData) => client.post("/bios/profile/update/", formData);
